import React from "react";

const Careers = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-white via-gray-50 to-blue-50 text-gray-900">
      {/* Header */}
      <header className="bg-white/90 backdrop-blur-md border-b border-gray-100 py-5 sticky top-0 z-10">
        <div className="max-w-6xl mx-auto px-6 flex justify-between items-center">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <img
              src="/logo.png"
              alt="Americar Logo"
              className="w-10 h-10 object-contain"
            />
            <span className="text-2xl font-semibold font-poppins text-blue-700">
              Americar Careers
            </span>
          </div>

          {/* Back Button */}
          <a
            href="/"
            className="text-blue-600 hover:text-blue-800 font-medium transition-all"
          >
            ← Back to Home
          </a>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-grow flex items-center justify-center text-center px-6">
        <div>
          <h1 className="text-4xl sm:text-5xl font-bold font-poppins text-gray-900 mb-4">
            No Openings Yet
          </h1>
          <p className="text-lg text-gray-600 max-w-md mx-auto leading-relaxed">
            We’re not hiring right now, but stay tuned — exciting opportunities
            are on the way.
          </p>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-400 py-8 text-center">
        <p className="text-sm">
          © 2025 Americar. All rights reserved. | Built with ❤️ by the Americar
          Team
        </p>
      </footer>
    </div>
  );
};

export default Careers;
